import React from "react"
import styled, { css } from "styled-components"
import { theme } from "Theme"
import mixins from "Styles"
import { StyledSelect, Spacer } from "Components/FormElements"

export class StepsOptionsSelect extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { optionsLink, label, name, placeholder, value, options, defaultMenuIsOpen, className } = this.props
    return (
      <>
        <h2>Step {this.props.currentStep}</h2>
        <StyledSelect
          optionsLink={optionsLink}
          label="Options:"
          name="options"
          placeholder="Please select one"
          value={[]}
          options={[
            { label: "Access Pass", value: "Access Pass" },
            { label: "Exhibit", value: "Exhibit" },
            {
              label: "Exhibit + Content",
              value: "Exhibit + Content",
            },
            { label: "Premier", value: "Premier" },
            {
              label: "Premier + Content",
              value: "Premier + Content",
            },
          ]}
          defaultMenuIsOpen={false}
          className="fullWidthElement"
        />
        <Spacer />
        <div className="buttonsWrapper">
          <button type="button" className="btn" onClick={this.props.previousStep}>
            Previous Step
          </button>
          <button type="button" className="btn" onClick={this.props.nextStep}>
            Next
          </button>
        </div>
      </>
    )
  }
}

export default StepsOptionsSelect
